import { render } from "./eye.svg?vue&type=template&id=31e03326?inline"
const script = {}
script.render = render

export default script